import { TypeEventEnum } from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { Dayjs } from 'dayjs'
import { ILocation, ITeam } from '../../../CreateEvent/type'

export interface IFormUpdateEvent {
  name?: string
  startDate?: Dayjs
  endDate?: Dayjs
  description?: string
  startDateRegister?: Dayjs
  endDateRegister?: Dayjs
  link?: string
  type?: TypeEventEnum
}

export enum TypeColumn {
  STRING = 'string',
  DATE = 'date',
  NUMBER = 'number',
  OTHER = 'other',
}

export enum RewardTypeEnum {
  SINGLE = 'INDIVIDUAL',
  GROUP = 'COLLECTIVE',
}

export const DefineRewardType = {
  [RewardTypeEnum.SINGLE]: 'Cá nhân',
  [RewardTypeEnum.GROUP]: 'Tập thể',
}

export interface IColumnActivity {
  name?: string
  type?: TypeColumn
  keyOfMainData?: keyof ITradeUnionMember
}

export interface IDataTumActivity extends ITradeUnionMember {
  [key: string]: string | number | Date | undefined | null | boolean
}

export interface IRewardActivity {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  id?: any
  name?: string
  description?: string
  gift?: string
  type?: RewardTypeEnum
  countPerReward?: number

  activity?: IActivityEvent
}

export interface IActivityEvent {
  id?: number
  title?: string
  valueCare?: string
  columns?: IColumnActivity[]
  data?: IDataTumActivity[]
  rewards?: IRewardActivity[]

  teams?: ITeam[]
  locations?: ILocation[]
}
